import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { TransactionService } from './transaction.service';
import { NgbActiveModal } from '@otas/modal/modal-ref';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { GlobalData } from '../../globalData';

@Component({
    selector: 'app-transaction-modal',
    templateUrl: './transaction-modal.component.html',
    styleUrls: ['./transaction-modal.component.css'],
    standalone: false
})
export class TransactionModalComponent implements OnInit {
  bank;
  @ViewChild('chequeField', { static: false }) cashElement: ElementRef;

  chequeNumber;
  submitted = false;
  allBankList: any = [] = [];
  transactionForm: UntypedFormGroup;
  chequeCleared = false;
  static mode: ModeOfPayment;
  static amount: number;
  transactionMode = ModeOfPayment.cheque;
  totalAmount: number = 0;
  totalSwipingAmount: number = 0;
  userData: any = {};
  constructor(private transactionService: TransactionService, private fb: UntypedFormBuilder, public activeModal: NgbActiveModal) {
    this.transactionForm = this.fb.group({
      bank: ['', [Validators.required]], chequeNumber: ['', [
        Validators.required,
        Validators.minLength(4),
        Validators.maxLength(15),
        Validators.pattern('^[a-zA-Z0-9 \'\-]+$')
      ]], posCharge: ''
    });
  }

  

  ngOnInit() {
    this.chequeCleared = true;
    this.transactionMode = TransactionModalComponent.mode;
    this.totalAmount = TransactionModalComponent.amount;
    this.userData = JSON.parse(sessionStorage.getItem('CURRENT_USER'));

    this.getAllbankList();
    
    if(this.transactionMode === ModeOfPayment.cheque || this.transactionMode === ModeOfPayment.netbanking) {
      this.transactionForm.get('bank').setValue((!!+this.userData.chequeBank) ? +this.userData.chequeBank : '');
    } else if(this.transactionMode === ModeOfPayment.pos) {
      this.transactionForm.get('posCharge').setValue((!!this.userData.poscharge) ? this.userData.poscharge : '');
      this.transactionForm.get('bank').setValue((!!this.userData.poschargebank) ? this.userData.poschargebank : '');
      this.totalSwipingAmount = (!!this.totalAmount) ? ((!!this.transactionForm.get('posCharge').value) ?
        (((+this.transactionForm.get('posCharge').value * this.totalAmount) / 100) + this.totalAmount) : this.totalAmount) : 0;
    } else if(this.transactionMode === ModeOfPayment.qrcode) {
      this.transactionForm.get('bank').setValue((!!+this.userData.qrBank) ? +this.userData.qrBank : '');
    }

    if (!!this.transactionForm.get('bank').value) {
      setTimeout(() => {
        this.cashElement.nativeElement.focus();
      }, 1000);
    }

  }

  // convenience getter for easy access to form fields
  get f() { return this.transactionForm.controls; }

  changeChequeClearance(event) {
    this.chequeCleared = !!this.chequeCleared ? false : true;
  }
  getAllbankList() {
    !!GlobalData.menus[0].array?.length ? this.allBankList = GlobalData.menus[0].array : this.allBankList = [];
    this.transactionService.getAllbankList().subscribe(response => {
      this.allBankList = response.result;

    });
  }
  addDetails() {
    // if(this.transactionForm.invalid) {
    //   this.transactionForm.setErrors({ ...this.transactionForm.errors, 'yourErrorName': true });
    //   return;
    // }
    let bankId = null;
    if (TransactionModalComponent.mode == ModeOfPayment.mo) {
      bankId = 18;
    } else if (!this.transactionForm.controls.bank.value || !this.transactionForm.controls.chequeNumber.value) {
      this.submitted = true;
      return;
    } else {
      bankId = this.transactionForm.controls.bank.value;
    }
    const details = {
      bank: bankId, isChequeCleared: this.chequeCleared, chequeNumber: this.transactionForm.controls.chequeNumber.value,
      charge: this.transactionForm.controls.posCharge.value
    };
    this.activeModal.close(details);
  }
  roundOff(amount: number): number {
    return Math.ceil(amount);
  }
}
export enum ModeOfPayment {
  cash = 'CASH', cheque = 'CHEQUE', pos = 'POS', qrcode = 'QRCODE', netbanking = 'NETBANKING', mo = 'MO', online = 'ONLINE'
}
